import * as Sentry from '@sentry/browser'

const isSentryEnabled = import.meta.env.VITE_SENTRY_DSN_PUBLIC && ['production', 'staging'].includes(import.meta.env.VITE_APP_ENV)

if (isSentryEnabled) {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                maskAllInputs: true,
            }),
        ],
        environment: import.meta.env.VITE_APP_ENV,
        tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
        replaysSessionSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE),
        replaysOnErrorSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE),
    })

    window.$sentry = {
        setUserId: id => {
            Sentry.setUser({ id })
        },
    }

    document.dispatchEvent(new CustomEvent('sentry:ready'))
}
